import { useState, useEffect } from "react"
import * as axios from "axios"
import { postPaywallContactUs } from "../../../../global/paywall/paywallApiUrls";

export const CalcalistContactUsComponenta = () => {
    const [formData, setFormData] = useState<any>({
        firstName: { id: 1, name: "firstName", type: "text", label: "שם פרטי", order: 1, value: "", isValid: false, error: '' },
        email: { id: 2, name: "email", type: "text", label: 'דוא"ל', order: 2, value: "", isValid: false, error: '' },
        phone: { id: 3, name: "phone", type: "tel", inputmode: "numeric", pattern: "[0-9]*", order: 3, label: "מספר טלפון", value: "", isValid: false, error: '' },

        subject: {
            id: 4, name: "subject", type: "select", label: "נושא הפניה", value: "", order: 4, isValid: false, options: [
                "תקלה טכנית",
                "בירור כספי",
                "תוכן",
                "בקשה לביטול מנוי",
                "אחר"
            ], error: ''
        },
        message: { id: 5, name: "message", type: "textarea", label: "תוכן ההודעה", value: "", order: 5, isValid: false, error: '' },
    });

    const [generalError, setGeneralError] = useState("");
    const [isSubmitted, setIsSubmitted] = useState(false);

    const validationSchema = {
        firstName: {
            required: true,
            message: "שדה חובה",
            validate: (value: string) => {
                if (value.length > 50) return "שם פרטי יכול להכיל עד 50 תווים";
                return /^[A-Za-zא-ת\u0590-\u05FF' ]{2,}$/u.test(value) || "שם פרטי יכול להכיל רק אותיות";
            },
        },
        email: {
            required: true,
            message: "שדה חובה",
            validate: (value: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) || "כתובת מייל לא תקינה",
        },
        phone: {
            required: true,
            message: "שדה חובה",
            validate: (value: string) => /^05\d{8}$/.test(value) || "מספר טלפון לא תקין",
        },
        subject: {
            required: true,
            message: "יש לבחור נושא פניה",
            validate: (value: string) => value.trim() !== "" || "יש לבחור נושא פניה",
        },
        message: {
            required: true,
            message: "שדה חובה",
            validate: (value: string) => {
                const trimmed = value.trim();
                if (trimmed.length < 10) return "הודעה חייבת להכיל לפחות 10 תווים";
                if (trimmed.length > 500) return "הודעה לא יכולה להכיל יותר מ-500 תווים";
                return true;
            }
        }
    };





    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const formData = {
            firstName: urlParams.get('firstName') || "",
            email: urlParams.get('email') || "",
            phone: urlParams.get('phone') || "",
            subject: urlParams.get('subject') || "",
            message: urlParams.get('message') || ""
        };
        const { firstName, email, phone, subject, message } = formData;

        if (!firstName || !email || !phone || !subject || !message) {
            return;
        }


        const firstNameValidation = validateField("firstName", firstName || "");
        const emailValidation = validateField("email", email || "");
        const phoneValidation = validateField("phone", phone || "");
        const subjectValidation = validateField("subject", subject || "");
        const messageValidation = validateField("message", message || "");

        setFormData(prevFormData => ({
            ...prevFormData,
            firstName: {
                ...prevFormData.firstName,
                value: firstName || "",
                isValid: firstNameValidation.isValid,
                error: firstNameValidation.error
            },
            email: {
                ...prevFormData.email,
                value: email || "",
                isValid: emailValidation.isValid,
                error: emailValidation.error
            },
            phone: {
                ...prevFormData.phone,
                value: phone || "",
                isValid: phoneValidation.isValid,
                error: phoneValidation.error
            },
            subject: {
                ...prevFormData.subject,
                value: subject || "",
                isValid: subjectValidation.isValid,
                error: subjectValidation.error
            },
            message: {
                ...prevFormData.message,
                value: message || "",
                isValid: messageValidation.isValid,
                error: messageValidation.error
            },
        }));
    }, []);

    const resetForm = () => {
        setFormData((prevFormData) => {
            const resetData = {};
            Object.keys(prevFormData).forEach((key) => {
                resetData[key] = { ...prevFormData[key], value: "", isValid: false, error: "" };
            });
            return resetData;
        });
        setGeneralError("");
    };

    const validateField = (name: string, value: string): { isValid: boolean; error: string } => {
        const field = validationSchema[name];
        if (!field) return { isValid: false, error: "שדה לא מוכר" };
        if (field.required && !value.trim()) {
            return { isValid: false, error: field.message };
        }
        const isValid = field.validate(value) === true;
        const error = isValid ? "" : field.validate(value) as string;
        return { isValid, error };
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const { isValid, error } = validateField(name, value);
        setFormData(prev => ({
            ...prev,
            [name]: { ...prev[name], value, isValid, error }
        }));
    };


    const handleSubmitForm = async (e) => {
        e.preventDefault();

        const formDataToSend = Object.keys(formData).reduce((acc, key) => {
            acc[key] = formData[key].value;
            return acc;
        }, {});

        try {
            const response = await handleSendFormData(formDataToSend);
            if (response && response.status === 200) {
                setIsSubmitted(true);
                resetForm();
            }
        } catch (error) {
            console.error("Error sending form data:", error);
            setGeneralError("שגיאה בשליחת הטופס. אנא נסו שוב מאוחר יותר.");
            return;
        }
    };


    const handleSendFormData = async (formData) => {
        try {
            return await axios.post(postPaywallContactUs(), formData);
        } catch (error) {
            console.error("Error sending form data:", error);
        }
    }

    const allFieldsValid = Object.values(formData).every((field: any) => field.isValid);
    const renderFields = () => {
        return Object.keys(formData).map((field) => {
            const inputField = formData[field];
            const renderInputField = () => {
                switch (inputField.type) {
                    case "select":
                        return (
                            <select
                                required
                                name={inputField.name}
                                value={inputField.value}
                                onChange={handleChange}
                                disabled={inputField.disabled}
                                className={inputField.error ? "error" : ""}
                            >
                                <option value="" hidden>
                                    {inputField.label}
                                </option>
                                {inputField.options.map((option, index) => (
                                    <option key={index} value={option}>
                                        {option}
                                    </option>
                                ))}
                            </select>
                        );
                    case "textarea":
                        return (
                            <textarea
                                name={inputField.name}
                                value={inputField.value}
                                onChange={handleChange}
                                disabled={inputField.disabled}
                                placeholder={inputField.label}
                                className={inputField.error ? "error" : ""}
                            />
                        );
                    default:
                        return (
                            <input
                                type={inputField.type}
                                name={inputField.name}
                                value={inputField.value}
                                onChange={handleChange}
                                disabled={inputField.disabled}
                                inputMode={inputField.inputmode}
                                pattern={inputField.pattern}
                                placeholder={inputField.label}
                                className={inputField.error ? "error" : ""}
                            />
                        );
                }
            };

            return (
                <div
                    className="input-field"
                    style={{ order: inputField.order }}
                    key={inputField.id}
                >
                    {renderInputField()}
                    {<span className="input-field-error">{inputField.error}</span>}
                </div>
            );
        });
    };


    return (
        <div className="CalcalistContactUsComponenta">
            <div className="digital-edition-label">המהדורה הדיגיטלית</div>
            <h1 className="title">צור קשר</h1>
            {isSubmitted && <span className="success-message">פנייתך נשלחה בהצלחה!</span>}
            {generalError && <span className="general-error">{generalError}</span>}
            <div className="inner-container">
                <div className="form-container">
                    <form id="contanct-us-form" onSubmit={handleSubmitForm}>
                        {renderFields()}
                    </form>
                </div>
                <div className="logo-container">
                    <div className="text">
                        <span>בכל נושא ועניין,</span><br />
                        <span>כתבו לנו ונחזור אליכם!</span>
                    </div>
                    <div className="contact-logo"></div>

                </div>
            </div>
            <button form="contanct-us-form" className="submit-button" type="submit" disabled={!allFieldsValid}>שליחה</button>
            <div className="terms-text">

                <span>לביטול מינוי כלכליסט יש לשלוח שם מלא וטלפון באחד מהאופנים הבאים</span>: בווסטאפ 052-9995005, בפקס 03-6933999, בדואר: נח מוזס 1 
ת"ד 438 ראשון לציון 7510302, בכתובת מייל <a href="mailto:manuy@calcalist.co.il">manuy@calcalist.co.il</a>.  או באמצעות טופס, למעט לרוכשים באמצעות
                חנויות סלולר שאז הביטול דרך APPLE STORE ו-GOOGLE PLAY בהתאמה
            </div>
        </div>
    )

}


CalcalistContactUsComponenta.siteScriptName = "CalcalistContactUsComponenta";